import React, { useEffect, useState, useRef } from "react";
import {
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row
} from "reactstrap";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import CompoundService from "services/Admin/CompoundService"
import UnitTypesService from "services/Admin/UnitTypesService"
import PropertyService from "services/Admin/PropertyService";
import SelectOptions from "components/SelectOptions"
import Select from "react-select";
import { useDispatch } from "react-redux";
import { appendFilters } from "store/adminFilter/actions";
const initialFormData = {
    unit_type: null,
    // compound_ids: null,
}
const FilterModal = ({ modal, toggle, onSumbit, filterData }) => {
    const dispatch = useDispatch()
    const [formData, setFormData] = useState(initialFormData)
    const [unitTypeOptions, setUnitTypeOptions] = useState([])

    useEffect(() => {
        if (filterData ?.unit_type ?.length) {
            setFormData((state) => ({ ...state, unit_type: [...filterData.unit_type] }))
        } else {
            setFormData((state) => ({ ...state, unit_type: null }))
        }
        // if (filterData ?.compound_ids ?.length) {
        //     setFormData((state) => ({ ...state, compound_ids: [...filterData.compound_ids] }))
        // } else {
        //     setFormData((state) => ({ ...state, compound_ids: null }))
        // }
    }, [])
    return (
        <AvForm className='form-horizontal'>
            <Modal isOpen={modal} toggle={toggle}
                className="rightModalSide scrollbar-container mt-0">
                <ModalHeader toggle={toggle}>
                    Unit Filters
            </ModalHeader>

                <ModalBody>
                    <Col md={12}>
                        <SelectOptions
                            label='unit type'
                            placeholder='Select'
                            options={unitTypeOptions}
                            handleSelectChange={(data) => {
                                setFormData({ ...formData, unit_type: data });
                            }}
                            selectedOption={formData.unit_type}
                            Service={UnitTypesService}
                            setOptions={(options) => {
                                setUnitTypeOptions(options)
                            }}
                            isMulti={true}

                        />
                    </Col>

                    {/* <Col md={12}>
                        <SelectOptions
                            label='Compound'
                            placeholder='Select'
                            options={compoundOptions}
                            handleSelectChange={(data) => {
                                setFormData({ ...formData, compound_ids: data });
                            }}
                            selectedOption={formData.compound_ids}
                            Service={CompoundService}
                            setOptions={(options) => {
                                setCompoundOptions(options)
                            }}
                            isMulti={true}

                        />
                    </Col> */}


                </ModalBody>
                <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                    <button
                        type='button'
                        className='btn btn-light w-120'
                        onClick={() => {
                            dispatch(appendFilters({unit_type: '', unit_type_ids:[]}))
                            setFormData(initialFormData)
                            onSumbit(initialFormData)
                        }}>
                        Reset Filter
                       </button>
                    <button type='button' onClick={() => {
                        onSumbit({
                            unit_type: formData.unit_type,
                            unit_type_ids: formData.unit_type?.map(type=> type?.value).join(),
                        })
                        toggle()
                    }}
                        className='btn btn-success  w-120'>
                        Apply Filter
                    </button>
                </ModalFooter>

            </Modal>
        </AvForm>

    )
}
export default FilterModal